/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePreSetupInput } from "../models/CreatePreSetupInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class PerfilClickAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns any Success
   * @throws ApiError
   */
  public createPreSetup({
    requestBody,
  }: {
    requestBody?: CreatePreSetupInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/perfil-click-setup",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public isEmailTaken({ email }: { email: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/perfil-click-setup/{email}",
      path: {
        email: email,
      },
    });
  }
}
